module.exports = __webpack_public_path__ + "img/AT0000002606224.a011ed00.png";